// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import withIconProps from '../withIconProps';

import TravelLogoVertical from '../_raw/ui/icon_travel_logo_vertical.svg';

export default withIconProps(TravelLogoVertical, {
  shouldSetDefaultSize: true,
  defaultHeight: 40,
  defaultWidth: 79,
});
